import React, { useState, useEffect } from "react";
import {
  createBrand,
  updateBrand,
  getManufacturers,
  getBrand,
} from "../../../Utility/Api";
import { toast } from "react-toastify";

export const EditBrands = ({
  showModal,
  setShowModal,
  fetchBrands,
  selectedBrand,
  isAddMode,
}) => {
  const [formData, setFormData] = useState({
    name: ""
  });
  const  [errors,setErrors]=useState({});

  useEffect(() => {
    if (isAddMode) {
      setFormData({
        name: "",
      });
    } else {
      setFormData({
        name: selectedBrand?.name || "",
      });
    }
  }, [selectedBrand]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors((prev) => ({
      ...prev,
      [name]: "", 
    }));
  };
  const handleclear = () => {
    setShowModal(false);
    setErrors({
      name: ""
    })
    setFormData({
      name: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = {};

        if (!formData.name) {
          validationErrors.name = "Brand title is required.";  
        }
       
    
        if (Object.keys(validationErrors).length > 0) {
          setErrors(validationErrors);
    
          return;
        }

    // Prepare the payload to be sent in the API request
    const payload = {
      brand_id: formData.brand_id,
      name: formData.name,

    };
    console.log("Submitting payload:", payload);

    try {
      if (isAddMode) {
        await createBrand(payload); // Create a new brand
        toast.success("Brand Added successfully");
      } else {
        await updateBrand(selectedBrand.brand_id, payload); // Update the existing brand
        toast.success("Brand Updated successfully");
      }
      handleclear();
      setShowModal(false); // Close the modal
      fetchBrands(); // Refresh the list of brands
    } catch (error) {
      console.error(
        "Error handling brand data:",
        error.response ? error.response.data : error.message
      );
      toast.error("Error handling brand data");
    }
  };

  return (
    <>
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h5 className="modal-title">
                  {isAddMode ? "Add Brand" : "Edit Brand"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => handleclear()}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/* Brand Name */}
                  <div className="form-group mb-3 d-flex align-items-center ">
                    <label className="col-3 mb-0 text-normal">Brand Name</label>
                    <div className="col-8">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control"
                      
                    />
                     {errors.name && (
                     <small className="text-danger">{errors.name}</small>
                      )}
                      </div>
                  </div>

                  <div className="mt-5 ">
                  <button
                    type="submit"
                    className="btn btn-success me-2 float-end"
                  >
                    {isAddMode ? "Add Brand" : "Update Brand"}
                  </button>
                  {/* &nbsp; */}
                  <button
                    type="button"
                    className="btn btn-secondary me-2 float-end"
                    onClick={() => handleclear()}
                  >
                    Cancel
                  </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
